import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _slicedToArray from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import debounce from './utils/debounce';
import style from './Vh.module.css';

function Vh(props) {
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      height = _React$useState2[0],
      setheight = _React$useState2[1]; // Helper


  var getWinHeight = function getWinHeight() {
    var win_height = 0;

    if (window.screen.height === window.innerHeight) {
      //  WITHOUT ios address bar  (fullscreen)
      win_height = window.screen.height;
    } else {
      // WITH ios address bar
      win_height = window.innerHeight;
    }

    return win_height;
  };

  var getOffset = function getOffset() {
    var _props$offset, _props$offset2, _props$offset3;

    var smallScreenOffset = (_props$offset = props.offset) !== null && _props$offset !== void 0 && _props$offset.sm ? props.offset.sm : 0;
    var largeScreenOffset = (_props$offset2 = props.offset) !== null && _props$offset2 !== void 0 && _props$offset2.lg ? props.offset.lg : (_props$offset3 = props.offset) !== null && _props$offset3 !== void 0 && _props$offset3.sm ? props.offset.sm : 0;
    var offset = window.innerWidth > 1023 ? largeScreenOffset : smallScreenOffset;
    return offset;
  };

  var setterHeight = function setterHeight() {
    if (props.smScreenOnly) {
      if (window.innerWidth > 1023) {
        setheight(0);
      } else {
        setheight(getWinHeight() - getOffset());
      }
    } else {
      setheight(getWinHeight() - getOffset());
    }
  }; // Callback 


  React.useEffect(function () {
    // Set initial height
    setterHeight(); // Listen on resize

    var debouncedHandleResize = debounce(function handleResize() {
      setterHeight();
    }, 200);
    window.addEventListener('resize', debouncedHandleResize);
    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []); // Set Vertical align middle if need

  var children = null;
  var heightStyle = {};
  var h = height === 0 ? 'auto' : height + 'px';

  if (props.alignMiddle) {
    children = /*#__PURE__*/_jsx("div", {
      className: style.aligner,
      children: /*#__PURE__*/_jsxs("div", {
        className: style.aligner_inner,
        children: [" ", props.children, " "]
      })
    });

    if (props.maxHeight) {
      heightStyle = {
        height: h,
        maxHeight: props.maxHeight + 'px'
      };
    } else {
      heightStyle = {
        height: h
      };
    }
  } else if (props.fixHeight) {
    children = props.children;

    if (props.maxHeight) {
      heightStyle = {
        height: h,
        maxHeight: props.maxHeight + 'px'
      };
    } else {
      heightStyle = {
        height: h
      };
    }
  } else {
    children = props.children;
    heightStyle = {
      minHeight: h
    };
  } // Renderer


  return /*#__PURE__*/_jsx("div", {
    className: "".concat(props.className ? props.className : '', " ").concat(style.container),
    style: heightStyle,
    children: children
  });
}

export default Vh;